import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { SectionInfo, SectionInfoProps } from '../../common-components/sectionInfo';

export const PrintPatientPayerDetails = React.memo(({ data }: { data: SectionInfoProps[] }) => {
  const { t } = useTranslation();

  return (
    <div>
      <Heading level={2} css={headerStyles}>
        {t('Patient & Payer Details')}
      </Heading>
      <div css={[cardStyles, patientPayerDetailsStyles]}>
        {data.map((item, index) => (
          <div key={index}>
            <SectionInfo label={item.label} value={item.value} />
          </div>
        ))}
      </div>
    </div>
  );
});

PrintPatientPayerDetails.displayName = 'PrintPatientPayerDetails';

const cardStyles = css`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  row-gap: ${theme.spacing(2)};
  column-gap: ${theme.spacing(4)};
`;

const headerStyles = css`
  padding: 2px 0 0 ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
  border-radius: ${theme.borderRadius.medium};
`;
const patientPayerDetailsStyles = css`
  margin-top: ${theme.spacing(2)};
  border: 1px solid ${theme.colors.neutral20};
  padding: ${theme.spacing(2)};
  border-radius: ${theme.borderRadius.medium};
  width: 100%;
`;
